import { IChapter } from '../models/IChapter';
import { IStrengthCard } from '../models/IStrengthCard';
import { IContentBase, IDashboardBlock } from '../models/IContentBase';
import { STRENGTH_TYPE } from '../constants';

import content from '../content/content';

const DEFAULT_CONTENT = content;

let CONTENT_BASE : IContentBase | undefined;

export default {
  setContentBase() {

    if (!CONTENT_BASE) {
      CONTENT_BASE = DEFAULT_CONTENT;
    }
  },

  getAllChapters(): IChapter[] {
    if (!CONTENT_BASE || !CONTENT_BASE.chapters) return [];

    return CONTENT_BASE.chapters;
  },

  getChapterByIdentifier(identifier: string): IChapter | undefined {
    if (!CONTENT_BASE || !CONTENT_BASE.chapters) return;

    return this.getAllChapters().find(chapter => chapter.chapterIdentifier === identifier);
  },

  getStrengthCards(strengthType?: STRENGTH_TYPE): IStrengthCard[] {
    if (!CONTENT_BASE || !CONTENT_BASE.strengthCards) return [];

    const strengths = CONTENT_BASE.strengthCards;

    if (strengthType) return strengths[strengthType];

    return ([] as IStrengthCard[])
      .concat(...Object.keys(strengths)
      .map(key => strengths[key as STRENGTH_TYPE]));
  },

  getWelcomeScreenBackgroundVideo() {
    if (!CONTENT_BASE) return '';
    return CONTENT_BASE.welcomeScreenVideoUrl;
  },

  getFinaleBackgroundImage() {
    if (!CONTENT_BASE) return '';
    return CONTENT_BASE.finaleBackgroundUrl;
  },

  getVideoOverlayBackgroundImage() {
    if (!CONTENT_BASE) return '';
    return CONTENT_BASE.videoOverlayBackgroundUrl;
  },

  getUrgentHelpContent(): IDashboardBlock | undefined {
    if (CONTENT_BASE) return CONTENT_BASE.urgentHelpBlock;
  },

  getChatMateContent(): IDashboardBlock | undefined {
    if (CONTENT_BASE) return CONTENT_BASE.chatMateBlock;
  },

}